import { AuthAction } from '../actions';
import * as constants from '../constants';
import { AuthState } from '../models';

export const authReducer = (state: AuthState = {},
                            action: AuthAction): AuthState => {

  switch (action.type) {
    case constants.AUTH_SUCCESS:
    case constants.AUTH_RENEW_SUCCESS:
      return {
        ...state, 
        authToken: action.authToken, 
        expertId: action.expertId,
        isAuthenticated: true,
        provider: action.provider,
        queues: action.queues,
        technicianName: action.name,
      };
    case constants.LOGOUT_SUCCESS:
      return {};
    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/authReducer.ts